export const bedTypes=["general",'icu','firstclass','luxury','suit']